export default __webpack_public_path__ + "static/media/bg.471de861.jpg";